// Values for dtoIn for requesting values to the table
export const FILTER_BY_USERNAME = "username";
export const FILTER_BY_EQUAL_TO_SCORE = "equalToScore";
export const FILTER_BY_GREATER_THAN_OR_EQUAL_TO_SCORE = "greaterThanOrEqualToScore";
export const FILTER_BY_LESS_THAN_OR_EQUAL_TO_SCORE = "lessThanOrEqualToScore";
